import React from 'react';

import Container from './Container';
import HorizontalLine from './HorizontalLine';

import OrderReceived from './OrderReceived';
import ShipmentState from './ShipmentState';
import DeliveryState from './DeliveryState';

export default ({ shipment, ...rest }) => {
  const { status, received_at, delivered_at, shipped_at, shipper, tracking_number, tracking_url, gokada_label_url } = shipment || {};
  return (
    <div {...rest}>
      <Container className="d-flex flex-md-row flex-column justify-content-between tw-w-full gap-4" style={{flexWrap:'wrap'}}>

        <HorizontalLine status={status} />
        <div style={{width:'30%'}}>
          <OrderReceived shipment={shipment} />
        </div>
        <div style={{width:'30%'}}>
          <ShipmentState
            status={status}
            shipped_at={shipped_at}
            shipper={shipper}
            tracking_number={tracking_number}
            tracking_url={tracking_url}
            gokada_label_url={gokada_label_url}
          />
        </div>
        <div style={{width:'30%'}}>
          <DeliveryState status={status} delivered_at={delivered_at} />
        </div>
      </Container>

    </div>
  );
};
